import React, { Component } from 'react'
import { SocialIcon } from 'react-social-icons';
import kyle from './images/kyle.png'
import alonzo from './images/alonzo.png'
import pete from './images/peter.jpeg'
import derek from './images/derek.jpg'
import sean from './images/sean.JPG'
export default class About extends Component {
    render() {
        return (
            <div>
                <h1 className='about-h1'>Meet the Birdzai Team</h1>
                <section className="about-team">
                    <article className="team">
                        <p className='team-name'>Kyle</p>
                        <img className="team-pic"src={kyle} alt=''/>
                        <p>
                        <SocialIcon url="https://www.linkedin.com/in/kyle-mayer88/" />   
                        <SocialIcon url="https://github.com/kylemayer" />
                        </p>
                    </article>
                    <article className="team">
                        <p className='team-name'>Alonzo</p>
                        <img className="team-pic"src={alonzo} alt=''/>
                        <p>
                        <SocialIcon url="https://www.linkedin.com/in/alonzo-anderson-8a6a27172/" />   
                        <SocialIcon url="https://github.com/Alonzo-Anderson" />
                        </p>

                    </article>
                    <article className="team">
                        <p className='team-name'>Derek</p>
                        <img className="team-pic"src={derek} alt=''/>
                        <p>
                        <SocialIcon url="https://www.linkedin.com/in/derekhudgins/" />   
                        <SocialIcon url="https://github.com/DerekHudgins" />  
                            </p>

                    </article>
                    <article className="team">
                        <p className='team-name'>Peter</p>
                        <img className="team-pic"src={pete} alt=''/>
                        <p>
                        <SocialIcon url="https://www.linkedin.com/in/petermontano/" />   
                        <SocialIcon url="https://github.com/montano-pete" /> 
                            </p>

                    </article>
                    <article className="team">
                        <p className='team-name'>Sean</p>
                        <img className="team-pic"src={sean} alt=''/>
                        <p>
                        <SocialIcon url="https://www.linkedin.com/in/simpson-sean/" />   
                        <SocialIcon url="https://github.com/simpson-sean" />
                            </p>

                    </article>
                </section>
            </div>
        )
    }
}
